import { render, staticRenderFns } from "./partnerWithdrawalsHistory.vue?vue&type=template&id=5b521304"
import script from "./partnerWithdrawalsHistory.vue?vue&type=script&lang=js"
export * from "./partnerWithdrawalsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports